import { h } from 'preact';

import Badge from 'components/badge/badge';

import s from 'components/badge/badgeUniversal.sss';

export default class BadgeUniversal extends Badge {
	s = s;

	renderBadge(props) {
		return (
			<div class={s.badgeWrapper}>
				{this.renderAlert(props)}
				{super.renderBadge(props)}
			</div>
		);
	}
}